import IconCart from '@kawaui/icons/build/icons/action/Cart'
import IconBack from '@kawaui/icons/build/icons/navigation/Back'

import { useEffect, useState } from 'react'

import { Action, FloatNavWrapper } from 'styles/sharedStyles'
import { goCart, historyBack } from 'utils/methods'

type Props = {
  onClickBack?: () => void
  rightIcon?: React.ReactNode
  onClickRightIcon?: () => void
}

const FloatNav = ({ onClickBack = historyBack, rightIcon, onClickRightIcon }: Props) => {
  const [hasScrolled, setHasScrolled] = useState(false)

  const handleScroll = () => {
    const position = window.pageYOffset

    setHasScrolled(position > 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <FloatNavWrapper>
      <Action hasScrolled={hasScrolled}>
        <div onClick={onClickBack}>
          <IconBack data-testid="floatNavBack" />
        </div>
      </Action>
      <Action hasScrolled={hasScrolled} onClick={onClickRightIcon ? onClickRightIcon : goCart}>
        {rightIcon ? rightIcon : <IconCart />}
      </Action>
    </FloatNavWrapper>
  )
}

export default FloatNav
